import type { Airport } from './api/flights.types';

const OTHER_COUNTRY_LABEL = 'Otros';

export function airportLabel(airport: Airport): string {
  const cityName = airport.cityName || '';
  const airportName = airport.airportName || airport.cityName || '';
  const airportCode = airport.airportCode || airport.cityCode || '';
  return `${cityName} - ${airportName} (${airportCode})`;
}

export function airportKey(airport: Airport): string {
  return String(airport.id ?? `${airport.cityCode}-${airport.airportCode ?? ''}`);
}

export function createCountryDisplayNames(): Intl.DisplayNames | null {
  try {
    return new Intl.DisplayNames(['es', 'en'], { type: 'region' });
  } catch {
    return null;
  }
}

/** Same country grouping labels as the uncustomized flights Autocomplete. */
export function airportCountryLabel(
  airport: Airport,
  countryDisplayNames: Intl.DisplayNames | null,
): string {
  if (airport.countryName) return airport.countryName;

  const code = airport.countryCode;
  if (!code) return OTHER_COUNTRY_LABEL;

  return countryDisplayNames?.of(code) || code;
}
